/* global setGaqPush */

export default function initBlogGAEvents() {
    sendGoogleAnalyticsEventOnBlogKeywordsSearch();
}

function sendGoogleAnalyticsEventOnBlogKeywordsSearch() {
    document.getElementById('blogSearchForm').addEventListener('submit', () => {
        const keywords = document.getElementById('blogSearchForm_keywords').value;
        if (keywords.length > 3) {
            setGaqPush('Blog', 'Tražilica', keywords);
        }
    });
}
